import React from 'react'

import { IncomingMessage, IncomingMessageProps } from './IncomingMessage'
import { OutgoingMessage, OutgoingMessageProps } from './OutgoingMessage'
import { OutgoingStoryMessage, OutgoingStoryMessageProps } from './OutgoingStoryMessage'

type MessageProps = OutgoingMessageProps | IncomingMessageProps | OutgoingStoryMessageProps

export function ChatMessage(props: MessageProps) {
  if (props.variant === 'outgoing') {
    return (
      <OutgoingMessage isPlaceholder={props.isPlaceholder} id={props.id} hasLike={props.hasLike}>
        {props.children}
      </OutgoingMessage>
    )
  }

  if (props.variant === 'incoming') {
    return (
      <IncomingMessage
        avatarUrl={props.avatarUrl}
        isPlaceholder={props.isPlaceholder}
        buttons={props.buttons}
        id={props.id}
      >
        {props.children}
      </IncomingMessage>
    )
  }

  if (props.variant === 'outgoing-story') {
    return (
      <OutgoingStoryMessage
        imageUrl={props.imageUrl}
        placeholderText={props.placeholderText}
        hasLike={props.hasLike}
        reaction={props.reaction}
        id={props.id}
      />
    )
  }

  return null
}

ChatMessage.displayName = 'Chat.Message'
